export default __webpack_public_path__ + "static/genie-f90e3e86b5212575bcc714c640b98608.jpg";